import React from "react";
import { Modal } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";

const SimModal = ({ showModal, onHide, centered = true, size, title, children }) => {
  return (
    <Modal show={showModal} onHide={onHide} centered={centered} size={size}>
      {/* <Modal.Header className="sim-modalheader">{title}</Modal.Header> */}
      <Modal.Body className="sim-modal-body">{children}</Modal.Body>
    </Modal>
  );
};

export default SimModal;
